import {USER_RELOAD} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import xhr from '~/frontend/src/utilities/xhr';
import setUser from '~/frontend/src/actions/user/setUser';


export type ReloadAction = {
    type : typeof USER_RELOAD;
}

/**
 * @memberOf! Actions
 *
 * @return {}
 */
const reload = () : Thunk<Promise<boolean>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<boolean> => {
    dispatch( {
        type: USER_RELOAD
    } );

    let retVal = false;

    const result = await xhr.post(
        `${BASE_URL}/api/user/reload`,
        undefined,
        undefined,
        'global_non_masking',
        'reloadUser',
        dispatch
    );

    if ( result?.data?.success && result.data.user ) {
        dispatch( setUser( result.data.user ) );

        retVal = true;
    }

    return retVal;
}

export type Reload = typeof reload;

export default reload;
